import { type ColorToken } from '@backrs_ui/common-ui';

import type { CollegeTier } from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

export type TierColors = Readonly<{ bg: ColorToken; border: ColorToken; text: ColorToken }>;

export const TIER_COLORS: Record<CollegeTier | 'none', TierColors> = {
  safety: { bg: 'Warning/50', border: 'Warning/200', text: 'Warning/700' },
  target: { bg: 'Success/50', border: 'Success/200', text: 'Success/700' },
  reach: { bg: 'Blue/50', border: 'Blue/200', text: 'Blue/700' },
  none: {
    bg: 'Colors/Background/bg-secondary',
    border: 'Colors/Border/border-secondary',
    text: 'Colors/Text/text-tertiary',
  },
};
